// Central Aurora support contact.
//
// The email address is displayed as a label everywhere in the app, but every
// clickable email link routes internally to /contact where an in-app form
// sends the message via Zoho SMTP to support@theauroramatch.com.
//
// This means users never have to leave the app, never need a mail app
// configured, and every device works — including inside the Emergent preview.

export const AURORA_SUPPORT_EMAIL = "support@theauroramatch.com";
export const AURORA_SUPPORT_CONTACT_PATH = "/contact";
